import React, { useState, useEffect } from "react";
import {
  Button,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Card,
  TextField,
  FormHelperText,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useAdminContext } from "../../../Hooks/AdminContext";
import BasicBreadcrumbs from "../../../components/GeneralComponents/BreadCrumbs";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { _Detail_Transaction } from "../../../DAL/Listing/TransactionList";
import { enqueueSnackbar } from "notistack";
import moment from "moment";
import CustomCircularProgress from "../../../components/CustomCircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { Scree_Base_List } from "../../../DAL/Listing/AgencyAddAcount";
import SingleSelectAutocomplete from "../../../components/AutoComplete/AutoComplete";
import {
  renderBankDetails,
  show_proper_words,
  uploadImage,
} from "../../../utils/constant";
import { clear_wallet_details_Update } from "../../../DAL/Listing/ActionsHistoy";
import { picBaseUrl } from "../../../config/config";
import styled from "styled-components";

const Input = styled("input")({
  display: "none",
});

export const DetailsClearWallet = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [file, setProfileImage] = useState();
  const [employee, setEmployee] = useState(null);
  const params = useParams();
  const { setnavbarTitle, socket } = useAdminContext();
  const [checked, setChecked] = useState(false);
  const [walletDetails, setWalletDetails] = useState({});
  const [taxError, setTaxError] = useState(false);
  const [formData, setFormData] = useState({
    withdrawAmount: "",
    taxAmount: "",
    message: "",
    image: "",
  });
  const amountAfterTax = formData.withdrawAmount - formData.taxAmount;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Validate tax amount
    if (name === "taxAmount") {
      if (Number(value) > Number(formData.withdrawAmount)) {
        setTaxError(true);
      } else {
        setTaxError(false);
      }
    }
  };
  const fileChangedHandler = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Allowed image types
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      enqueueSnackbar("Only JPG, JPEG, PNG, and WEBP files are allowed.", {
        variant: "error",
      });
      return;
    }

    // If valid, update state
    setProfileImage(URL.createObjectURL(file));
    setFormData({
      ...formData,
      ["image"]: file,
    });
  };

  const getDetailsData = async () => {
    setLoading(true);
    const response = await _Detail_Transaction(params.id);
    if (response.code === 200) {
      setWalletDetails({
        ...response?.transaction,
        ...response?.wallet,
      });
      setFormData((prev) => {
        return {
          ...prev,
          withdrawAmount:
            response?.wallet?.total_available_balance?.toFixed(2) || 0,
        };
      });
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleUpdateStatus = async (status) => {
    setLoading(true);

    let imagePath = formData.image;

    if (formData.image && typeof formData.image !== "string") {
      const uploadedPath = await uploadImage(formData.image);
      if (!uploadedPath) {
        setLoading(false);
        return; // Stop execution if upload fails
      }
      imagePath = uploadedPath;
    }

    const data = {
      status: status,
      employee_id: employee.id,
      attachment_url: imagePath,
      message: formData.message,
      total_amount: parseFloat(formData.withdrawAmount) || 0,
      amount: parseFloat(amountAfterTax) || 0,
      processed_fee: parseFloat(formData.taxAmount) || 0,
    };

    // if (status === "failed") {
    //   delete data.amount;
    //   delete data.processed_fee;
    //   delete data.total_amount;
    // }

    const response = await clear_wallet_details_Update(data, params.id);
    if (response.code === 200) {
      socket.emit("wallet_deposit_event", {
        notification: response.notification,
      });
      enqueueSnackbar(response.message, { variant: "success" });
      navigate(`/clear-wallet-balance`);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  useEffect(() => {
    setnavbarTitle("Clear Wallet Balance");
    handleGetDetailUser();
  }, []);

  useEffect(() => {
    setnavbarTitle("Clear Wallet Details");
  }, []);

  useEffect(() => {
    getDetailsData();
  }, []);

  const BreadCrumbsList = [
    {
      title: "Clear Wallet Balance",
      navigation: "/clear-wallet-balance",
      active: false,
    },
    {
      title: "Clear Wallet Balance Request Details",
      navigation: "",
      status: "Active",
    },
  ];

  const enteredAmount = parseFloat(formData.withdrawAmount);
  const availableAmount = parseFloat(
    walletDetails?.total_available_balance?.toFixed(2)
  );
  // console.log(walletDetails, "=========================wallet");

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="container-fluid">
      <form>
        <div className="row">
          <div className="col-12 mb-3 mt-5 mt-md-0">
            <BasicBreadcrumbs items={BreadCrumbsList} />
          </div>
          <div className="col-12">
            <Card style={{ border: "2px solid #bebebe21" }}>
              <div className="row p-3">
                <div className="col-12">
                  <div className="mb-3">
                    <span>User Clear Wallet Balance Request</span>
                  </div>
                  <div className="mb-3 d-flex align-items-center svg-color date-color">
                    <Icon icon="uiw:date" />
                    <span className="ms-2">
                      {walletDetails &&
                        moment(walletDetails.date_time).format(
                          "DD MMM YY hh:mm A"
                        )}
                    </span>
                  </div>
                  <div className="row detail_page_list gy-3 gy-md-0">
                    {renderBankDetails(walletDetails)}

                    <hr className="my-3" />
                    {(walletDetails?.status === "failed" ||
                      walletDetails?.status === "pending") && (
                      <div className="col-12 mt-3 mb-4">
                        <div className="d-flex flex-wrap w-100 div-style ps-0 ms-0 pt-0">
                          <div className="col-lg-5 col-md-5 col-12">
                            <p className="">Upload Image</p>
                            <FormHelperText className="pt-0 text-muted">
                              Image ("JPG", "JPEG", "PNG","WEBP")
                            </FormHelperText>
                          </div>
                          <div className="col-lg-2 col-md-2 col-12">
                            {file ? (
                              <img
                                className="image-border"
                                src={file}
                                height="50"
                              />
                            ) : (
                              <>
                                {formData.image && (
                                  <img
                                    className="image-border"
                                    src={picBaseUrl + formData.image}
                                    height="50"
                                  />
                                )}
                              </>
                            )}
                          </div>
                          <div className="col-lg-5 col-md-5 col-12 text-end pt-2">
                            <label htmlFor="contained-button-file">
                              <Input
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                name="image"
                                onChange={fileChangedHandler}
                              />

                              <Button
                                className="small-contained-button"
                                startIcon={
                                  <FileUploadIcon
                                    style={{
                                      fill: "#fff",
                                    }}
                                  />
                                }
                                component="span"
                              >
                                Upload
                              </Button>
                            </label>
                          </div>
                        </div>
                        {formData?.image?.name && (
                          <p className="text-secondary mb-0">
                            {formData?.image?.name}
                          </p>
                        )}
                      </div>
                    )}
                    <div
                      className={
                        walletDetails?.status === "failed" ||
                        walletDetails?.status === "pending"
                          ? "col-12 col-md-6 col-lg-4"
                          : "col-6 mb-3"
                      }
                    >
                      <SingleSelectAutocomplete
                        inputLabel={"Approve or Reject by"}
                        selectedOption={employee}
                        setSelectedOption={setEmployee}
                        optionsList={employeeArray}
                        required={true}
                        name="name"
                        size="medium"
                      />
                    </div>
                    {(walletDetails?.status === "failed" ||
                      walletDetails?.status === "pending") && (
                      <>
                        <div className="col-12 col-md-6 col-lg-4">
                          <TextField
                            label="Withdraw Amount $"
                            type="number"
                            helperText={
                              !formData.withdrawAmount
                                ? ""
                                : enteredAmount > availableAmount
                                ? "Please enter amount less than or equal to available balance"
                                : enteredAmount < availableAmount
                                ? "Please enter amount equal to available balance"
                                : ""
                            }
                            fullWidth
                            required
                            name="withdrawAmount"
                            value={formData.withdrawAmount}
                            onChange={handleInputChange}
                            placeholder="Enter amount"
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                          <TextField
                            required
                            label="Ads Spend Fee $"
                            type="number"
                            fullWidth
                            name="taxAmount"
                            value={formData.taxAmount}
                            onChange={handleInputChange}
                            placeholder="Enter tax"
                            error={taxError}
                            helperText={
                              taxError
                                ? "Processor Fee cannot exceed withdraw amount"
                                : ""
                            }
                          />
                        </div>

                        <div className="col-12 col-md-6 col-lg-6 d-flex flex-wrap p-3">
                          <div className="mt-2 me-3">
                            Amount After Processor Fee:
                          </div>
                          <div className="text-muted mt-2">
                            ${amountAfterTax.toFixed(2)}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-12">
                      <TextField
                        label="Message"
                        multiline
                        minRows={3}
                        fullWidth
                        required
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Enter message"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-3 d-flex flex-wrap justify-content-between">
                  <div className="col-12 col-md-8">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={(e) => setChecked(e.target.checked)}
                        />
                      }
                      label="Are you sure you want to Approve or Reject this transaction?"
                    />
                  </div>
                  <div className="text-end col-12 col-md-4 mt-3 mt-md-0">
                    {walletDetails?.status === "pending" ? (
                      <>
                        <Tooltip
                          title={taxError ? "Fix the tax amount first" : ""}
                        >
                          <span>
                            <Button
                              variant="contained"
                              onClick={() => handleUpdateStatus("succeeded")}
                              disabled={
                                taxError ||
                                !formData.withdrawAmount ||
                                !formData.taxAmount ||
                                !employee?.name ||
                                !formData.message ||
                                !checked ||
                                loading ||
                                enteredAmount > availableAmount ||
                                enteredAmount < availableAmount
                              }
                              className="me-2"
                            >
                              Approve
                            </Button>
                          </span>
                        </Tooltip>
                        <Tooltip title={!checked ? "Please check the box" : ""}>
                          <span>
                            <Button
                              variant="outlined"
                              color="error"
                              onClick={() => handleUpdateStatus("failed")}
                              disabled={
                                !checked ||
                                !employee?.name ||
                                !formData.message ||
                                loading
                              }
                            >
                              Reject
                            </Button>
                          </span>
                        </Tooltip>
                      </>
                    ) : walletDetails?.status === "failed" ? (
                      <Tooltip
                        title={taxError ? "Fix the tax amount first" : ""}
                      >
                        <span>
                          <Button
                            variant="contained"
                            onClick={() => handleUpdateStatus("succeeded")}
                            disabled={
                              taxError ||
                              !formData.withdrawAmount ||
                              !formData.taxAmount ||
                              !employee?.name ||
                              !formData.message ||
                              !checked ||
                              loading ||
                              enteredAmount > availableAmount ||
                              enteredAmount < availableAmount
                            }
                            className="me-2"
                          >
                            Approve
                          </Button>
                        </span>
                      </Tooltip>
                    ) : walletDetails?.status === "succeeded" ? (
                      <Tooltip title={!checked ? "Please check the box" : ""}>
                        <span>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleUpdateStatus("failed")}
                            disabled={
                              !checked ||
                              !employee?.name ||
                              !formData.message ||
                              loading
                            }
                          >
                            Reject
                          </Button>
                        </span>
                      </Tooltip>
                    ) : null}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </form>
    </div>
  );
};
